import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './CustomSectionHeading.scss';


const CustomSectionHeading = ({ children, className }) => (
  <div
    className={classNames(
      'custom-section__heading',
      className,
    )}
  >
    {children}
  </div>
);

CustomSectionHeading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

CustomSectionHeading.defaultProps = {
  children: undefined,
  className: undefined,
};

export default CustomSectionHeading;
